import { Modal, Radio } from "antd";
import { ReactComponent as Cross } from "assets/svg/closeBox.svg";

// @ts-ignore
import styles from "./styles.module.scss";

// @ts-ignore
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// @ts-ignore
import { duplicatePlan } from "modules/actions/PlanActions";
import { useNavigate } from "react-router-dom";

export default function DuplicateModal({
  visible,
  handleCloseModal,
}: {
  visible: boolean;
  handleCloseModal: () => void;
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(
    (state: {
      auth: {
        user: {
          data: {
            external_accounts: {
              decision_and_project: string;
            }[];
          };
        };
      };
    }) => state.auth
  );

  const userId =
    user?.data?.external_accounts?.find(
      (account: { decision_and_project: string }) =>
        account.decision_and_project
    )?.decision_and_project ?? null;

  const { planDetails } = useSelector(
    (state: {
      plan: {
        plan: {
          planDetails: {
            encrypted_id: string;
          };
        };
      };
    }) => state.plan.plan
  );

  const [isLoading, setIsLoading] = useState(false);
  const [duplicateType, setDuplicateType] = useState<"duplicate" | "structure">(
    "duplicate"
  );

  const handleClose = (data: { id: string }) => {
    handleCloseModal();
    setIsLoading(false);
    if (data?.id) {
      navigate(`/project-planner/plan-details/${data?.id}`);
    }
  };

  const handleDuplicatePlan = () => {
    setIsLoading(true);

    const payload = {
      project_id: planDetails?.encrypted_id,
      owner: userId,
      clone_type: duplicateType,
    };
    dispatch(duplicatePlan(payload, handleClose));
  };

  return (
    <Modal
      className={"deleteModal"}
      centered
      closable={false}
      title={false}
      maskClosable={false}
      footer={null}
      onCancel={handleCloseModal}
      open={visible}
      width={520}
    >
      <div className={styles.modal_header}>
        <h3>Duplicate Project Plan</h3>
        <Cross onClick={handleCloseModal} className={"c-pointer"} />
      </div>

      <div className={styles.modal_body}>
        <h4 className={styles.choose_plan}>
          Choose how to duplicate your project plan.{" "}
        </h4>

        <Radio.Group
          value={duplicateType}
          onChange={(e) => setDuplicateType(e.target.value)}
          size="large"
        >
          <div className={styles.duplicate}>
            <div className={styles.duplicate_header}>
              <Radio value="duplicate" className="radio-primary" />
              <h3>Duplicate Project Plan</h3>
            </div>
            <h4>Create an exact copy of the original plan.</h4>
          </div>

          <div className={styles.duplicate}>
            <div className={styles.duplicate_header}>
              <Radio value="structure" className="radio-primary" />
              <h3>Duplicate structure only</h3>
            </div>
            <h4>
              Copy only the project name, details, resources, and collaborators,
              so you can add a new goal, categories, action items, and dates.
            </h4>
          </div>
        </Radio.Group>
      </div>

      <div className={styles.modal_footer}>
        <button onClick={handleCloseModal}>Cancel</button>
        <button
          onClick={handleDuplicatePlan}
          disabled={isLoading || !planDetails?.encrypted_id || !userId}
        >
          {isLoading ? <LoadingOutlined /> : "Duplicate"}
        </button>
      </div>
    </Modal>
  );
}
